import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Full Truckload Services',
      description: 'Dedicated transportation solutions for your full truckload shipments with guaranteed capacity and on-time delivery.',
    },
    {
      icon: 'ri-box-3-line',
      title: 'Less Than Truckload',
      description: 'Cost-effective LTL shipping options for smaller freight volumes with flexible scheduling and competitive rates.',
    },
    {
      icon: 'ri-time-line',
      title: 'Expedited Shipping',
      description: 'Time-critical delivery services ensuring your urgent shipments arrive exactly when you need them.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Regional Distribution',
      description: 'Strategic regional coverage across the Midwest with optimized routes and local expertise.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#FFF8F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3"></span>
            <span className="text-[#FF8C42] text-sm font-semibold uppercase tracking-wider">
              Our Services
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2A2A2A] mb-6">
            Comprehensive Logistics Solutions
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto">
            From full truckload to expedited shipping, we provide tailored transportation services to meet your unique business needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#FF8C42] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2A2A2A] mb-4">
                {service.title}
              </h3>
              <p className="text-[#6B6B6B] leading-relaxed mb-6">
                {service.description}
              </p>
              <Link
                to="/products-services"
                className="inline-flex items-center text-[#FF8C42] font-semibold hover:gap-2 transition-all duration-300 cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/products-services"
            className="inline-block bg-[#FF8C42] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#D4693A] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;